var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEntericon = function SvgEntericon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.8.8H14a.4.4 0 0 0-.4.4v8.4H3.464l2.752-2.752a.392.392 0 0 0 0-.56l-.568-.568a.4.4 0 0 0-.568 0L.976 9.824a.616.616 0 0 0-.176.424v.304a.6.6 0 0 0 .176.424l4.112 4.104a.4.4 0 0 0 .568 0l.568-.56a.4.4 0 0 0 0-.568L3.464 11.2H13.6a1.6 1.6 0 0 0 1.6-1.6V1.2a.4.4 0 0 0-.4-.4Z"
  })));
};
export default SvgEntericon;